let sellingplan = "";
let variantid = "47067747680592";

document.getElementById("sp-method").addEventListener("change", function(){
    var selectedOption = this.options[this.selectedIndex].value;
    sellingplan = selectedOption;
});

document.addEventListener('DOMContentLoaded', function() {
    var oneTimePurchaseSwitch = document.querySelector('#oneTimePurchase');
    var subscribeSwitch = document.querySelector('#subscribe');

    oneTimePurchaseSwitch.addEventListener('change', function() {
        if (oneTimePurchaseSwitch.checked) {
            subscribeSwitch.checked = false;
        }
    });

    subscribeSwitch.addEventListener('change', function() {
        if (subscribeSwitch.checked) {
            oneTimePurchaseSwitch.checked = false;
            var subscriptionRadio = document.getElementById('loop-radio-4706774768059268bcf6b8808a05a81bbe8d6ee9ebeb9dff81de87');
            if (subscriptionRadio) {
                subscriptionRadio.click();
                console.log("Subscription option clicked.");
            } else {
                console.error("Subscription radio button not found.");
            }
        } else {
            // Click the one-time purchase radio button when checkbox is unchecked
            var oneTimePurchaseRadio = document.getElementById('loop-one-time-purchase-8592246997328');
            if (oneTimePurchaseRadio) {
                oneTimePurchaseRadio.click();
                console.log("One-time purchase option clicked.");
            } else {
                console.error("One-time purchase radio button not found.");
            }
        }
    }); // <-- closing subscribeSwitch addEventListener
});
